var prodcat = prodcat || {};

prodcat.ui = prodcat.ui || {};
prodcat.data = prodcat.data || {};
var site = site || {};

(function ($) {
  $(document).on('product.skuSelect', '.js-product', function (e, skuBaseId, hasDramming) {
    // don't execute only on init for dramming product
    if (hasDramming === 'noshade') {
      return;
    }
    var $product = $(this);
    var $shadesGrid = $product.find('.js-product-full-shades-grid');
    var $selectedShade = $shadesGrid.find('.js-product-full-shades-grid-item[data-sku-base-id="' + skuBaseId + '"]');
    var $selectedDot = $selectedShade.find('.product-full-shades-flyout__shade-dot');
    var styles = {
      backgroundColor: $selectedShade.data('hex'),
      borderColor: $selectedShade.data('hex')
    };

    if ($shadesGrid.length < 1) {
      return null;
    }
    $product.attr('data-sku-base-id', skuBaseId);
    if (hasDramming) {
      $product.find('.product-full-shades-flyout__shade-dot.drammingactive').removeAttr('style').removeClass('drammingactive');
      $selectedDot.css(styles).addClass('drammingactive');
    } else {
      $product.find('.product-full-shades-flyout__shade-dot').not('.drammingactive').removeAttr('style');
      $selectedDot.css(styles);
    }
    $('body').removeClass('flyout-shades-active');
  });

  Drupal.behaviors.productFullShadesFlyoutV1 = {
    orderAlphabetical: function ($shadeItem, $shadesGrid) {
      $shadeItem.sort(function (a, b) {
        var aShade = $(a).data('shade-name');
        var bShade = $(b).data('shade-name');

        return aShade < bShade ? -1 : aShade > bShade ? 1 : 0;
      }).appendTo($shadesGrid);
    },
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      if ($('.js-second-shade-select-option').length) {
        self.drammingPage = true;
      }
      var $flyout = $('.product-full-shades-flyout-v1', context);
      var $product = $flyout.closest('.js-product');
      var $shadeItem = $product.find('.js-product-full-shades-flyout-list-item');
      var $shadesGrid = $('.js-product-full-shades-grid', $flyout);
      var $flyoutTrigger = $('.js-product-full-shades-flyout-trigger', context);
      var $flyoutCloser = $('.js-product-full-shades-flyout-close', $flyout);

      $shadeItem.once().on('click', function () {
        var $this = $(this);
        var skuBaseId = $this.data('sku-base-id');

        $product.trigger('product.skuSelect', skuBaseId);
        $product.trigger('product.skuSelect', [skuBaseId, self.toggleShade]);
        if (self.drammingPage) {
          self.toggleShade = !self.toggleShade;
        }
      });

      $flyoutCloser.once().on('click', function (e) {
        e.preventDefault();
        $('body').removeClass('flyout-shades-active');
      });

      if ($flyoutTrigger.length) {
        $flyoutTrigger.once().on('click', function () {
          $('body').addClass('flyout-shades-active');
        });
      }

      self.orderAlphabetical($shadeItem, $shadesGrid);
    },
    toggleShade: false,
    drammingPage: false,
    attached: false
  };
})(jQuery);
